import { differenceInDays, addDays } from 'date-fns';

export const RecurrenceCalculationUtils = {
  isDayOfWeek: (date, daysOfWeek) => {
    const dayName = date.toLocaleDateString('en-US', { weekday: 'long' });
    return daysOfWeek.includes(dayName);
  },

  calculateOccurrences: (periodicity, daysOfWeek = [], startDate, endDate, numberOfOccurrences) => {
    if (numberOfOccurrences) {
      return numberOfOccurrences;
    }

    if (!endDate) {
      throw new Error('End date must be provided if number of occurrences is not specified.');
    }

    const start = new Date(startDate);
    const end = new Date(endDate);

    if (periodicity === 'daily') {
      return differenceInDays(end, start) + 1;
    } else if (periodicity === 'weekly') {
      let occurrences = 0;
      let currentDate = start;

      while (currentDate <= end) {
        if (RecurrenceCalculationUtils.isDayOfWeek(currentDate, daysOfWeek)) {
          occurrences++;
        }
        currentDate = addDays(currentDate, 1);
      }

      return occurrences;
    } else {
      throw new Error("Invalid periodicity. Must be 'quotidien' or 'hebdomadaire'.");
    }
  },
};
